import type { Util } from '../../../types/util';
import type { BannerVariantsType } from './index';

const base: Util.CSSProperties = {
  borderWidth: '1px',
  borderStyle: 'solid',
};

const alertBannerButton: Util.VariantCSSKeys<BannerVariantsType> = {
  alert: {
    ...base,
    borderColor: 'red.50',
  },
  notice: {
    ...base,
    borderColor: 'green.20',
  },
  warning: {
    ...base,
    borderColor: 'yellow.10',
  },
  white: {
    ...base,
    borderColor: 'white',
  },
  announcement: {
    ...base,
    borderColor: 'blue.60',
    color: 'white',
  },
};

export default alertBannerButton;
